import React, { useState, useEffect, useContext } from "react";
import LetUsComponent from "../../components/LetUsComponent/LetUsComponent";
import FrontBackConnect from "../../components/FrontBackConnect/FrontBackConnect";
import OurServices from "../../components/OurServices/OurServices";
import MainBlock from "../../components/MainBlock/MainBlock";
import WhyShouldYouChooseUs from "../../components/WhyShouldYouChooseUs/WhyShouldYouChooseUs";
import NewsMainBlockContainer from "../../components/NewsMainBlockContainer/NewsMainBlockContainer";
import CompaniesBlock from "../../components/CompaniesBlock/CompaniesBlock";
import ContactUs from "../../components/ContactUs/ContactUs";
import { ThemeContext } from "../../App";



export default function MainPage() {

  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div>
      <MainBlock />
      <div style={theme === "dark" ? { background: "linear-gradient(to bottom, black, #121212)" } : { background: "#F6F6F6" }}>
        <LetUsComponent />
        <FrontBackConnect />
        <OurServices />
      </div>
      <WhyShouldYouChooseUs />
      <NewsMainBlockContainer />
      <CompaniesBlock />
      <ContactUs />
    </div>
  );
}
